import { useMutation } from "react-query";
import { addMGA } from "../../../../../actions/Utilities/MGA";

const useAddMGA = () => {
  return useMutation(addMGA);
};
export default useAddMGA;
